export const GET_PORTAL_AUDIT_LOGS_REQUEST = "GET_PORTAL_AUDIT_LOGS_REQUEST";
export const GET_PORTAL_AUDIT_LOGS_SUCCESS = "GET_PORTAL_AUDIT_LOGS_SUCCESS";
export const GET_PORTAL_AUDIT_LOGS_FAIL = "GET_PORTAL_AUDIT_LOGS_FAIL";
